import React from "react"

export default function CookieList() {
  return <div id="ot-sdk-cookie-policy"></div>
}
